// MeetControlBarIconButton — round icon-button base used by mic/cam/screen/
// captions/share-link/settings (MeetControlBar) AND the shell-root
// MeetCallWidget's mic/return/leave controls. Split out of ControlBar.js
// (bundle-fold, 2026-08-01) so the widget's eager slice doesn't have to pull
// in the whole ~20KB MeetControlBar component tree just for this one shared
// base — registered via key name so `extends: 'MeetControlBarIconButton'`
// resolves through the smbls component registry regardless of which file
// defined it.
// One control height in the bar: the brand `controlH` (44px), the height of
// its text capsules — `C` was 44.5px at this font size. Never shrinks inside
// the row that scrolls. The dock (CallWidget) sets its own smaller size.
export const MeetControlBarIconButton = {
  tag: 'button',
  padding: 'Z',
  round: '100%',
  border: 'none',
  cursor: 'pointer',
  fontSize: 'A',
  width: 'controlH',
  height: 'controlH',
  flexShrink: '0',
  align: 'center center',
  theme: 'secondary'
}
